import {
  BannerData,
  UserData,
  TransactionsData,
  PolygonData,
  LocationData,
  CentreData,
  RoleData,
} from "../../types/models/master/MasterApp";

import {
  GET_BANNERS,
  SET_BANNER_DATA,
  CREATE_BANNER,
  UPDATE_BANNER,
  RESET_BANNER,
  GET_USERS,
  SET_USER_DATA,
  CREATE_USER,
  UPDATE_USER,
  GET_TRANSACTIONS,
  SET_TRANSACTION_DATA,
  GET_POLYGON,
  SET_Polygon_DATA,
  CREATE_POLYGON,
  RESET_POLYGON,
  GET_Location,
  SET_Location_DATA,
  GET_Centre,
  SET_Centre_DATA,
  GET_ROLES,
  GET_NETWORK_PARTNERS,
  GET_COF_USERS,

} from "../../types/actions/Master.action";

import { SET_ROLE } from "../../types/actions/roleMaster.action";
import { AppActions } from "../../types";

export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentBanner: BannerData | null;
  banners: BannerData[];
  bannerCount: number;
  currentUser: UserData | null;
  users: UserData[];
  userCount: number;
  currentTransaction: TransactionsData | null;
  transactions: TransactionsData[];
  transactionCount: number;
  currentPolygon: PolygonData | null;
  polygon: PolygonData[];
  polygonCount: number;
  currentLocation: LocationData | null;
  location: LocationData[];
  locationCount: number;
  currentCentre: CentreData | null;
  centre: CentreData[];
  centreCount: number;
  roles: RoleData[];
  currentRole: RoleData | null;
} = {
  banners: [],
  bannerCount: 0,
  currentBanner: null,
  currentUser: null,
  users: [],
  userCount: 0,
  transactions: [],
  transactionCount: 0,
  currentTransaction: null,
  polygon: [],
  polygonCount: 0,
  currentPolygon: null,
  currentLocation: null,
  location: [],
  locationCount: 0,
  currentCentre: null,
  centre: [],
  centreCount: 0,
  roles: [],
  currentRole: null,
};

const Master = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case RESET_BANNER:
      return { ...state, currentBanner: null };

    case GET_BANNERS:
      return {
        ...state,
        banners: action.payload.rows || [],
        bannerCount: action.payload.count || 0,
      };

    case SET_BANNER_DATA:
      return {
        ...state,
        currentBanner: action.payload,
      };

    case CREATE_BANNER:
      return {
        ...state,
        banners: [...state.banners, action.payload],
      };

    case UPDATE_BANNER:
      return {
        ...state,
        banners: state.banners.map((banner) =>
          banner.id === action.payload.id ? action.payload : banner
        ),
      };

    case GET_USERS:
      return {
        ...state,
        users: action.payload.users,
        userCount: action.payload.userCount,
      };

    case SET_USER_DATA:
      return {
        ...state,
        currentUser: action.payload,
      };

    case CREATE_USER:
      return {
        ...state,
        users: [...state.users, action.payload],
      };

    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
      };

    case GET_ROLES:
      return {
        ...state,
        roles: action.payload,
      };

    case SET_ROLE:
      return {
        ...state,
        currentRole: action.payload,
      };

    case GET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.transactions,
        transactionCount: action.payload.transactionCount,
      };

    case SET_TRANSACTION_DATA:
      return {
        ...state,
        currentTransaction: action.payload,
      };

    case RESET_POLYGON:
      return {
        ...state,
        polygon: [],
        currentPolygon: null,
      };

    case CREATE_POLYGON:
      return {
        ...state,
        polygon: [...state.polygon, action.payload],
      };

    case GET_POLYGON:
      return {
        ...state,
        polygon: action.payload.rows || [],
        polygonCount: action.payload.count || 0,
      };

    case SET_Polygon_DATA:
      return {
        ...state,
        currentPolygon: action.payload,
      };

    case GET_Location:
      return {
        ...state,
        location: action.payload.location,
        locationCount: action.payload.locationCount,
      };

    case SET_Location_DATA:
      return {
        ...state,
        currentLocation: action.payload,
      };

    case GET_Centre:
      return {
        ...state,
        centre: action.payload.centre,
        centreCount: action.payload.centreCount,
      };

    case SET_Centre_DATA:
      return {
        ...state,
        currentCentre: action.payload,
      };

      case GET_NETWORK_PARTNERS:
  return {
    ...state,
    networkPartners: action.payload,
  };
  case GET_COF_USERS:
  return {
    ...state,
    cofUsers: action.payload,
  };


    default:
      return state;
  }
};

export default Master;
